import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import Text from "components/Text";
import "./ChatModal.scss";
import Loader from "components/Loader";
import { addDefaultStaffRounded } from "utils";
import InfiniteScroll from "react-infinite-scroll-component";
import { LoaderIcon } from "react-hot-toast";
import PerformanceReviewSearchBar from "accountOwner/pages/PerformanceReview/components/PerformanceReviewSearchBar";
import OutsideClickHandler from "react-outside-click-handler";

function AddMemberInExistingGroupPopup(props) {
  const { t, stateData, closeModal, selectedUsers } = props;
  const { state, otherMethods, updateMethods } = stateData;
  const {
    staffMembers,
    selectedStaff,
    searchText,
    isLoadingStaffList,
    actionInProgress,
    hasMoreStaff,
    hasMoreOffices,
    offices,
    selectedOffices,
    selectedDesignations,
    designations,
    isNewConversationOfficePopupOpen,
  } = state;
  const {
    isThisUserSelected,
    handleSelectStaff,
    addNewMemberInExistingGroup,
    disableOtherUsers,
    loadMoreStaff,
    loadMoreOffices,
    searchStaffHandler,
    handleOfficeFilterForStaff,
    handleDesignationFilterForStaff,
    selectedOfficesLabel,
    selectedRolesLabel,
    resetStaffListFilterStates,
  } = otherMethods;

  const { setSelectedStaff, setIsNewConversationOfficePopupOpen } = updateMethods;
  const [isRoleFilterPopupOpen, setIsRoleFilterPopupOpen] = useState(false);

  useEffect(() => {
    setSelectedStaff([...selectedUsers]);
    return () => {
      resetStaffListFilterStates();
    };
  }, []);

  return (
    <Modal
      isOpen={true}
      toggle={() => {
        closeModal(false);
      }}
      className="modal-dialog-centered modal-width-660 new-grop-modal"
      modalClassName="custom-modal"
    >
      {(isLoadingStaffList || actionInProgress) && <Loader />}
      <span
        className="close-btn"
        onClick={() => {
          closeModal(false);
        }}
      >
        <img src={require("assets/images/cross.svg").default} alt="close" />
      </span>
      <ModalBody>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          {t("messenger.newGroup")}
        </Text>
        <div className="new-group-searchbar-dropdown-wrapper">
          <div className="new-group-search-row">
            <PerformanceReviewSearchBar
              searchValue={searchText}
              handleSearchTerm={(ev) => searchStaffHandler(ev.target.value)}
              placeholderText="Search by name"
              isFromPatientConversation={true}
            />
          </div>
          <div className="new-group-filter-row">
            <OutsideClickHandler
              onOutsideClick={() => setIsNewConversationOfficePopupOpen(false)}
            >
              <Dropdown
                isOpen={isNewConversationOfficePopupOpen}
                toggle={() => {}}
                className="cursor-pointer new-group-filter-dropdown"
              >
                <DropdownToggle
                  caret={false}
                  onClick={() =>
                    setIsNewConversationOfficePopupOpen(
                      !isNewConversationOfficePopupOpen,
                    )
                  }
                  className="dropdown-btn dropdown-new"
                  tag="div"
                >
                  <span className="dropdown-name-toggle">
                    {selectedOfficesLabel(selectedOffices)}
                    {selectedOffices?.some((option) => option.value !== 0) && (
                      <span className="notification-dot-new">•</span>
                    )}
                  </span>

                  <img
                    src={require("assets/images/chat-down-arrow.svg").default}
                    className="caret-img"
                    alt="caret"
                  />
                </DropdownToggle>
                <DropdownMenu end id="offices-list" className="menu-new">
                  <InfiniteScroll
                    dataLength={offices?.length}
                    hasMore={hasMoreOffices}
                    next={loadMoreOffices}
                    scrollableTarget="offices-list"
                    loader={
                      <DropdownItem tag="div">
                        <LoaderIcon style={{ margin: "0 auto" }} />
                      </DropdownItem>
                    }
                    scrollThreshold={0.5}
                  >
                    {offices.map((of) => (
                      <DropdownItem key={of.value} tag="div" title={of.label}>
                        <div className="ch-checkbox">
                          <label className="mb-0">
                            <input
                              value={of.value}
                              name={of.name}
                              checked={
                                selectedOffices?.length
                                  ? selectedOffices?.some(
                                      (item) => item.value === of.value,
                                    )
                                  : !of.value
                              }
                              onChange={() => handleOfficeFilterForStaff(of)}
                              type="checkbox"
                            />
                            <span> {of.label} </span>
                          </label>
                        </div>
                      </DropdownItem>
                    ))}
                  </InfiniteScroll>
                </DropdownMenu>
              </Dropdown>
            </OutsideClickHandler>

            <OutsideClickHandler
              onOutsideClick={() => setIsRoleFilterPopupOpen(false)}
            >
              <Dropdown
                isOpen={isRoleFilterPopupOpen}
                toggle={() => {}}
                className="cursor-pointer new-group-filter-dropdown"
              >
                <DropdownToggle
                  caret={false}
                  onClick={() =>
                    setIsRoleFilterPopupOpen(!isRoleFilterPopupOpen)
                  }
                  className="dropdown-btn dropdown-new"
                  tag="div"
                >
                  <span className="dropdown-name-toggle">
                    {selectedRolesLabel(selectedDesignations)}
                    {selectedDesignations?.some((option) => option.value !== 0) && (
                      <span className="notification-dot-new">•</span>
                    )}
                  </span>

                  <img
                    src={require("assets/images/chat-down-arrow.svg").default}
                    className="caret-img"
                    alt="caret"
                  />
                </DropdownToggle>
                <DropdownMenu end id="roles-list" className="menu-new">
                  {designations.map((role) => (
                    <DropdownItem key={role.value} tag="div" title={role.label}>
                      <div className="ch-checkbox">
                        <label className="mb-0">
                          <input
                            value={role.value}
                            checked={
                              selectedDesignations?.length
                                ? selectedDesignations?.some(
                                    (item) => item.value === role.value,
                                  )
                                : !role.value
                            }
                            onChange={() => handleDesignationFilterForStaff(role)}
                            type="checkbox"
                          />
                          <span> {role.label} </span>
                        </label>
                      </div>
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </OutsideClickHandler>
          </div>
        </div>
        {selectedStaff?.length > 0 && (
          <Text
            size="12px"
            marginBottom="10px"
            weight="400"
            color="rgb(111, 119, 136)"
          >
            {selectedStaff.length} {t("Selected")}
          </Text>
        )}

        {staffMembers?.length > 0 && (
          <InfiniteScroll
            dataLength={staffMembers.length}
            hasMore={hasMoreStaff}
            next={loadMoreStaff}
            scrollableTarget="scrollableDiv"
          >
            <ul className={"modal-employee-list group-list"} id="scrollableDiv">
              {staffMembers
                .filter((staff) =>
                  searchText
                    ? staff.name
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                    : true
                )
                .map((staff) => {
                  const isExistingMember = selectedUsers?.some(
                    (user) => user?.id === staff?.id,
                  );
                  return (
                    <li key={staff.id + staff.officeId}>
                      <div
                        className={`ch-checkbox ${
                          isExistingMember || disableOtherUsers(staff)
                            ? "disable-btns"
                            : ""
                        }`}
                      >
                        <label>
                          <input
                            type="checkbox"
                            checked={isThisUserSelected(staff)}
                            onChange={(e) => handleSelectStaff(e, staff)}
                            disabled={
                              disableOtherUsers(staff) || isExistingMember
                            }
                          />
                          <span>
                            <img
                              src={staff.profilePic}
                              alt="profile-pic"
                              onError={addDefaultStaffRounded}
                            />
                            <div>
                              {" "}
                              {staff.name}
                            </div>
                          </span>
                        </label>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </InfiniteScroll>
        )}
        {!staffMembers?.length && (
          <div className="empty-channel-list text-center col-md-7 mx-auto py-5">
            <img
              src={require("assets/images/empty-icon.svg").default}
              alt="no-staff"
            />
            <h3> {t("messenger.noUserFound")}</h3>
            <p> {t("messenger.noUserFoundDesc")}</p>
          </div>
        )}
        <div className="d-sm-flex btn-box">
          <button
            type="button"
            disabled={!staffMembers?.length}
            onClick={() => {
              addNewMemberInExistingGroup();
              closeModal(false);
            }}
            className={
              "button button-round button-shadow  w-sm-100  mr-sm-3 mb-2"
            }
          >
            {t("messenger.addMember")}
          </button>

          <button
            type="button"
            onClick={() => {
              closeModal(false);
            }}
            className="button mb-md-2 btn-mobile-link button-round button-border button-dark"
          >
            {t("cancel")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(AddMemberInExistingGroupPopup);
